/* eslint-disable no-case-declarations */
import { getAllCategoriesService, deleteCategoryService } from '../services/contentService';
import { compareLocal, sortBy } from '../utils/helpers';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// async thunk
export const getAllCategories = createAsyncThunk(
  'categories/getAllCategories',
  async () => {
    const response = await getAllCategoriesService();
    return response.data;
  }
);

export const removeCategory = createAsyncThunk(
  'categories/removeCategory',
  async (id) => {
    await deleteCategoryService(id);
    return id;
  }
);

// slice
const categoriesSlice = createSlice({
  name: 'categories',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllCategories.pending, (state) => {
        console.log('Fetching all categories...');
      })
      .addCase(getAllCategories.fulfilled, (state, action) => {
        return { ...state, ...action.payload };
      })
      .addCase(getAllCategories.rejected, (state, action) => {
        console.error('Failed to fetch categories:', action.error);
      })
      .addCase(removeCategory.pending, (state) => {
        console.log('Removing category...');
      })
      .addCase(removeCategory.fulfilled, (state, action) => {
        const { [action.payload]: _, ...newState } = state;
        return newState;
      })
      .addCase(removeCategory.rejected, (state, action) => {
        console.error('Failed to remove category:', action.error);
      });
  },
});

export default categoriesSlice.reducer;
export const { actions: categoriesActions } = categoriesSlice;

// Selectors
export const selectCategoriesSortOrder = (state) =>
  sortBy(Object.keys(state.categories), [
    (a, b) => compareLocal(state.categories[a], state.categories[b]),
  ]);
